import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import { Evaluation, Capabilities, Workflow, Analytics, NotFound } from './pages/InnerPage';
import RequestDemo from './pages/RequestDemo';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/"              element={<Home />} />
          <Route path="/evaluation"    element={<Evaluation />} />
          <Route path="/capabilities"  element={<Capabilities />} />
          <Route path="/workflow"      element={<Workflow />} />
          <Route path="/analytics"     element={<Analytics />} />
          <Route path="/request-demo"  element={<RequestDemo />} />
          <Route path="*"              element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
